import { useEffect, useState } from "react"
import { approveUsers, deleteUsers, fetchUser, fetchUserAccess, rejectUsers, suspendUsers, updateUserData } from "../UsersApi";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentLang, selectTranslations } from "../../../services/i18n/i18nSlice";

import suspend_img from '../../../assets/images/archive.svg'
import trash_img from '../../../assets/images/trash.svg'
import close_img from '../../../assets/images/close.svg'
import check_img from '../images/check.svg'
import reject_img from '../images/x.svg'


import { selectUserFields } from "../../../features/User/userSlice";
import { Col, Form, Tab, Tabs } from "react-bootstrap";
import { API_URL, DEFAULT_FIELDS, USER_STATUS } from "../../../config/constants";
import Select from "react-select";
import { setLoading } from "../../../services/global/globalSlice";
import { toast } from "react-toastify";
import GroupReducedTable from "./GroupReducedTable";
import UserExams from "./UserExams";

export default function UserModal (props) {

    const dispatch = useDispatch()
    const t = useSelector(selectTranslations)
    const currentLang = useSelector(selectCurrentLang)
    const [showModal, setShowModal] = useState(false)
    const [validatedForm, setValidatedForm] = useState(false)
    const [userData, setUserData] = useState({})
    const [userAccessData, setUserAccessData] = useState({})
    const userFields = useSelector(selectUserFields)
     const [confirmModal, setConfirmModal] = useState({
        title: "",
        text: "",
        onClose: null,
        onConfirm: null,
        confirmCta: "",
        closeCta: ""
    })

    const [groupsRowSelection, setGroupsRowSelection] = useState({})

    const processExtraFields = () => {
        let extra_fields = []
        let field_id = null
        userData?.extra_fields?.forEach((f)=>{
            console.log(f);
            field_id = f.field_id
            var field_data = userFields.find(_f => _f.field_id === field_id) || null
            if(!field_data){
                toast.error(t.users.settings.field_not_found)
                return;
            }
            const field_value = f?.values
            if(field_value)
                extra_fields.push({field_id: field_id, values:field_data?.field_type === "datetime" ? `${new Date(field_value).toISOString().substring(0,19)}+00:00` : field_value})
        })
        return extra_fields
    }

    const loadUserData = async () => {
        dispatch(setLoading(true))
        const response = await fetchUser(props.userId)
        if(response.success){
            setUserData(response.data)
            setShowModal(true)
            dispatch(setLoading(false))
        } else {
            dispatch(setLoading(false))
        }
    }

    const loadUserAccess = async () => {
        const response = await fetchUserAccess(props.userId)
        if(response.success){
            setUserAccessData(response.data?.folders?.filter(f => f.state !== "deleted"))
        } else {
            toast.error(t.user.error_loading_access)
        }
    }

    const handleUpdateUserField = (type='default', field_id,  value, field_type='text') => {
        console.log(type, field_id, value, field_type);
        let _userData = structuredClone(userData)
        if(field_type === "choices")
            if(Array.isArray(value))
                value = value.map((v)=>v.value)
            else
                value = [value.value]
        if(type === "default")
            _userData[field_id] = value
        else if(type === "compensational_measures")
            _userData["compensational_measures"] = {
                ..._userData?.compensational_measures,
                [field_id]: value
            }
        else {
            let idf = _userData.extra_fields.findIndex((e) => e.field_id === field_id);
            if(idf >= 0)
                _userData.extra_fields[idf].values = value
            else
                _userData.extra_fields.push({field_id:field_id, values:value})
        }
        _userData.is_saved = false
        setUserData(_userData)
    }

    const handleUpdateUserData = async (event) => {
        const form = event.currentTarget;
        setValidatedForm(true);
        console.log(form.checkValidity());
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        } else {
            event.preventDefault();
            event.stopPropagation();
            let _userData = structuredClone(userData)
            const extra_fields = processExtraFields()
            _userData['extra_fields'] = extra_fields
            _userData['groups'] = _userData?.groups?.map(g => g.group_id)
            const response = await updateUserData(_userData)
            if(response.success){
                toast.success(t.messages.update_success)
                setUserData(response.data)
                setShowModal(true)
                dispatch(setLoading(false))
            } else {
                dispatch(setLoading(false))
            }
            
        }
    };

    const handleApproveUser = async () => {
        const users_id = []
        if(userData.state==="waiting_admin_check")
            users_id.push(userData.user_id)
        else {
            toast.error(t.user.already_confirmed_user)
            return;
        }

        if(users_id.length > 0){
            dispatch(setLoading(true))
            const users_data = {
                users_ids : users_id
            }
            const response = await approveUsers(users_data)
            if(response.success){
                toast.success(t.users.approve_succes)
                dispatch(setLoading(false))
                loadUserData()
            } else {
                toast.error(t.users.error_while_approving)
                dispatch(setLoading(false))
            }
        }
    }
    const handleRejectUser = async () => {
        const users_id = []
        if(userData.state==="waiting_admin_check")
            users_id.push(userData.user_id)
        else {
            toast.error(t.user.already_confirmed_user)
            return;
        }

        if(users_id.length > 0){
            dispatch(setLoading(true))
            const users_data = {
                users_ids : users_id
            }
            const response = await rejectUsers(users_data)
            if(response.success){
                toast.success(t.users.approve_succes)
                dispatch(setLoading(false))
                loadUserData()
            } else {
                toast.error(t.users.error_while_approving)
                dispatch(setLoading(false))
            }
        }
    }

    const handleSuspendUser = async () => {
        let _userData = structuredClone(userData)
        const extra_fields = processExtraFields()
        _userData.extra_fields = extra_fields
        _userData.state = "suspended"
        const response = await updateUserData(_userData)
        if(response.success){
            toast.success(t.user.suspended_user)
            setUserData(response.data)
            setShowModal(true)
            dispatch(setLoading(false))
        } else {
            dispatch(setLoading(false))
        }
    }

    const handleActivateUser = async () => {
        let _userData = structuredClone(userData)
        const extra_fields = processExtraFields()
        _userData.extra_fields = extra_fields
        _userData.state = "active"
        const response = await updateUserData(_userData)
        if(response.success){
            toast.success(t.user.ativated_user)
            setUserData(response.data)
            setShowModal(true)
            dispatch(setLoading(false))
        } else {
            dispatch(setLoading(false))
        }
    }

    const handelDeleteUser = async () => {
        let _userData = structuredClone(userData)
        const extra_fields = processExtraFields()
        _userData.extra_fields = extra_fields
        _userData.is_deleted = true
        const response = await updateUserData(_userData)
        if(response.success){
            toast.success(t.user.deleted_user)
            setUserData(response.data)
            setShowModal(true)
            dispatch(setLoading(false))
        } else {
            dispatch(setLoading(false))
        }
    };


    const closeConfirmModal = () => {
        setConfirmModal({
            ...confirmModal,
            show: false
        })
    }

    const onClose = () => {
        setShowModal(false)
        props.onCloseModal()
    }

    useEffect(()=>{
        if(props.userId !== null){
            loadUserData()
            loadUserAccess()
        }
    },[props.userId])

    return (
        <>
        <Modal
            show={showModal}
            onHide={onClose}
            keyboard={false}
            centered
            size={'xl'}
        >
            <Modal.Body>
                {
                    userData.state === "waiting_for_approval" ? 
                    <>
                        <div className="d-flex">
                            <h2>{t.user.user_waiting}</h2>
                            <img src={close_img} onClick={onClose} />
                        </div>
                        <p className="mt-3">{userData.email}</p>
                        <div className="d-flex justify-content-end">
                            <div className='d-flex pointer' style={{color:"#181818",fontWeight:"500"}}>
                                <div className='d-flex' onClick={handleApproveUser}>
                                    <img src={check_img} />
                                    {t.users.accept}
                                </div>
                                <div className='d-flex ms-3 pointer' style={{color:"#181818",fontWeight:"500"}}>
                                    <img src={reject_img} onClick={handleRejectUser} />
                                    {t.users.reject}
                                </div>
                            </div>  
                        </div>
                    </> :
                    <>
                    <div className="d-flex justify-content-between">
                    <h2 className="">{userData.firstname} {userData.lastname}</h2>
                    <div className='d-flex justify-content-end mb-2'>
                        <div className='d-flex align-items-center pe-3'>
                            {
                                userData.state === "active" ?
                                <div className='d-flex align-items-center pe-3 border-end border-2 pointer'style={{color:"#181818",fontWeight:"500"}} onClick={handleSuspendUser}>
                                    <img src={suspend_img} />
                                    <span className='ms-1 '>{t.users.suspend}</span>
                                </div> :
                                <div className='d-flex align-items-center pe-3 border-end border-2 pointer'style={{color:"#181818",fontWeight:"500"}} onClick={handleActivateUser}>
                                    <img src={check_img} />
                                    <span className='ms-1 '>{t.users.reactivate}</span>
                                </div>
                            }
                            
                            <div className='d-flex align-items-center ps-3 pointer'style={{color:"#181818",fontWeight:"500"}} onClick={handelDeleteUser} >
                                <img src={trash_img} />
                                <span className='ms-1 '>{t.actions.delete}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <Tabs
                    defaultActiveKey="general"
                    id="noanim-tab-example"
                    className="mt-3 mb-4 rounded_tabs"
                >
                    <Tab eventKey="general" title={t.user.personal_data}>
                        <Form onSubmit={handleUpdateUserData} noValidate validated={validatedForm}>
                            <div className="d-flex flex-wrap justify-content-start">
                                <Form.Group className="mb-3 col-5 me-3">
                                    <Form.Label>ID</Form.Label>
                                    <Form.Control className="auto-width" type="text" disabled value={userData.user_id || '' }  />
                                </Form.Group>
                                <Form.Group className="mb-3 col-5 me-3">
                                    <Form.Label>E-mail</Form.Label>
                                    <Form.Control className="auto-width" type="text" disabled value={userData.email || '' }  />
                                </Form.Group>
                                {
                                    userFields?.map((f)=>{
                                        const field_id = f.field_id
                                        if(DEFAULT_FIELDS.includes(field_id)){
                                            return(
                                                <Form.Group controlId={field_id} key={field_id} className="mb-3 col-5 me-3">
                                                    <Form.Label>{f.field_names[currentLang]}</Form.Label>
                                                    <Form.Control className="auto-width" required={f.field_level === 0} type={f.field_type} value={userData[field_id] || '' } onChange={(e)=>handleUpdateUserField('default', field_id, e.target.value)} />
                                                    <Form.Control.Feedback  type="invalid">
                                                        <small className="text-danger">{t.forms.invalid_input}</small>
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            )
                                        } else {
                                            return(
                                                <Form.Group controlId={field_id} key={field_id} className="mb-3 col-5 me-3">
                                                    <Form.Label>{f.field_names[currentLang]}</Form.Label>
                                                    {
                                                        f.field_type === 'datetime'?
                                                        <>
                                                            <Form.Control className="auto-width" required={f.field_level === 0} type={'date'} value={userData?.extra_fields?.find(e => e.field_id === field_id)?.values?.substring(0,10) || ''}  onChange={(e)=>handleUpdateUserField('extra', field_id,  e.target.value, f.field_type)} />
                                                            <Form.Control.Feedback  type="invalid">
                                                                <small className="text-danger">{t.forms.invalid_input}</small>
                                                            </Form.Control.Feedback>
                                                        </>
                                                        : ""
                                                    }
                                                    {
                                                        f.field_type === 'text'?
                                                        <>
                                                            <Form.Control className="auto-width" required={f.field_level === 0} type={'text'} value={userData?.extra_fields?.find(e => e.field_id === field_id)?.values || ''}  onChange={(e)=>handleUpdateUserField('extra', field_id,  e.target.value, f.field_type)}  />
                                                            <Form.Control.Feedback  type="invalid">
                                                                <small className="text-danger">{t.forms.invalid_input}</small>
                                                            </Form.Control.Feedback>
                                                        </>: ""
                                                    }
                                                    {
                                                        f.field_type === 'singular' ||  f.field_type === "multiple"?
                                                            <>
                                                                <Select  
                                                                    options={f.choices?.map((c)=>{return({ value: c, label: c })})}
                                                                    isMulti={f.field_type === "multiple"}
                                                                    closeMenuOnSelect={false}
                                                                    hideSelectedOptions={false}
                                                                    required={f.field_level === 0} 
                                                                    allowSelectAll={true}
                                                                    value={
                                                                            f.field_type === 'singular' ?
                                                                                (userData?.extra_fields?.find(e => e.field_id === field_id)?.values[0]) ? { value: userData?.extra_fields.find(e => e.field_id === field_id)?.values[0], label: userData?.extra_fields.find(e => e.field_id === field_id)?.values[0] } : ''
                                                                            : userData?.extra_fields?.find(e => e.field_id === field_id)?.values?.map((c)=>{return({ value: c, label: c })}) || ''
                                                                        }                                                        
                                                                    classNamePrefix="react-select"
                                                                    className=" auto-width"
                                                                    onChange={(e)=>handleUpdateUserField('extra', field_id,  e, 'choices')} 
                                                                />
                                                                {f.field_level === 0 && ! userData?.extra_fields?.find(e => e.field_id === field_id)?.values?.length > 0 ?
                                                                    <small className="text-danger">{t.forms.invalid_select}</small>
                                                                : null}
                                                            </>
                                                        : ""
                                                    }
                                                </Form.Group>
                                                
                                            )
                                        } 
                                    })
                                }
                                <Form.Group className="mb-3 col-2 me-3">
                                    <Form.Label className="d-block">{t.users.fields.status}</Form.Label>
                                    <span className='status_label' style={{color:`${USER_STATUS[userData.state]?.color}`, background: `${USER_STATUS[userData.state]?.background}`}}>{t.users.status[userData.state]}</span> 
                                </Form.Group>
                                <Form.Group className="mb-3 col-2 me-3">
                                    <Form.Label className="d-block">{t.users.fields.last_online_date}</Form.Label>
                                    <span>{new Date(userData?.last_online_date)?.toLocaleDateString()}</span>
                                </Form.Group>
                                <div className="mt-4 d-flex w-100 justify-content-between">
                                    <button className="secondary" onClick={onClose}>
                                        {t.buttons.exit_without_save}
                                    </button>
                                    <button type="submit" >
                                        {t.buttons.save_and_exit}
                                    </button>
                                </div>
                            </div>
                        </Form>
                    </Tab>
                    {
                        (userAccessData && userAccessData.length >0) &&
                            <Tab eventKey="access" title={t.user.access_data}>
                                <ul>
                                    {Object.keys(Object.groupBy(userAccessData, ({ parent_folder_id }) => parent_folder_id)).map((key,index)=>{
                                        if(
                                            userAccessData.find(f => f.folder_id === key) &&
                                            !userAccessData.find(f => f.folder_id === userAccessData.find(f => f.folder_id === key)?.parent_folder_id)
                                        )
                                            return(
                                                <li key={index} className="mb-3">
                                                    {
                                                        userAccessData.find(f => f.folder_id === key)?.icon_url &&
                                                            <img src={`${API_URL}${userAccessData.find(f => f.folder_id === key).icon_url}`} className="me-2" style={{maxWidth:"20px"}} />
                                                    }
                                                    {userAccessData.find(f => f.folder_id === key).name}
                                                    <ul>
                                                        <RenderedSubfolder userAccessData={userAccessData} folderId={key} />
                                                    </ul>
                                                </li>
                                            )
                                    })}
                                </ul>
                            </Tab>
                    }
                    <Tab eventKey="groups" title={`${t.user.groups} (${userData?.groups?.length})`}> 
                        <GroupReducedTable 
                            data={userData?.groups}
                            rowSelection={groupsRowSelection} 
                            setRowSelection={setGroupsRowSelection}
                        />
                    </Tab>
                    <Tab eventKey="exams" title={`${t.user.exams}`}> 
                        <UserExams 
                            userId={userData?.user_id}
                        />
                    </Tab>
                    <Tab eventKey="dsa" title={`${t.user.exam_measures}`}> 
                        <Form.Group className="mb-3 col-5 me-3">
                            <Form.Label>Percentuale tempo aggiuntivo</Form.Label>
                            <Form.Control 
                                className="auto-width" 
                                type="text" value={userData?.compensational_measures?.additional_time_percentage || '' }  
                                onChange={(e)=>handleUpdateUserField('compensational_measures', "additional_time_percentage",  e.target.value)} 
                            />
                        </Form.Group>
                       <Form.Group className="mb-3 col-5 me-3">
                            <Form.Label>Calcolatrice abilitata</Form.Label>
                            <Form.Check 
                                type="switch"
                                checked={userData?.compensational_measures?.calculator_enabled || false }  
                                onChange={(e)=>handleUpdateUserField('compensational_measures', "calculator_enabled",  e.target.checked)} 
                            />
                        </Form.Group>
                    </Tab>
                </Tabs>
                    </>
                }
                
                
            </Modal.Body>
        </Modal>
        </>
    )
}


function RenderedSubfolder ({userAccessData, folderId}) {
    return(
        <>
            {userAccessData.map((folder,i_1)=>{
                if(folder.parent_folder_id === folderId)
                    return(
                        <li key={i_1}>
                            {
                                folder?.icon_url &&
                                    <img src={`${API_URL}${folder.icon_url}`} className="me-2" style={{maxWidth:"20px"}} />
                            }
                            {folder.name}
                            <ul>
                                <RenderedSubfolder userAccessData={userAccessData} folderId={folder.folder_id} />
                            </ul>
                        </li>
                    )
            })}
        </>
    )
}